(() => {
  const moneyValue = (text) => {
    const normalized = String(text || '')
      .replace(/[^0-9,.-]/g, '')
      .replace(/,/g, '');
    const value = Number.parseFloat(normalized);
    return Number.isFinite(value) ? value : null;
  };

  const formatMoney = (value) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en-US';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (_error) {
      return `$${value.toFixed(2)}`;
    }
  };

  const closestBlock = (element) => element?.closest('.block') || null;

  const updateSavings = (productInfo) => {
    productInfo.querySelectorAll('.pc-savings').forEach((badge) => badge.remove());
    return;
    const price = productInfo.querySelector('.price__sale');
    const saleText = price?.querySelector('.price-item--sale.price-item--last')?.textContent;
    const regularText = price?.querySelector('s.price-item--regular')?.textContent;
    const sale = moneyValue(saleText);
    const regular = moneyValue(regularText);
    let savings = price?.querySelector('.pc-savings');

    if (sale === null || regular === null || regular <= sale) {
      savings?.remove();
      return;
    }

    if (!savings) {
      savings = document.createElement('span');
      savings.className = 'pc-savings';
      price.appendChild(savings);
    }

    const percentage = Math.round(((regular - sale) / regular) * 100);
    const savingsText = `Save ${percentage}%`;
    if (savings.textContent !== savingsText) savings.textContent = savingsText;
  };

  const trimPaymentMethods = (paymentBlock) => {
    const list = paymentBlock?.querySelector('.product-list-payment');
    if (!list || list.dataset.pcTrimmed === 'true') return;

    const preferredOrder = [
      'Shop Pay',
      'Apple Pay',
      'Visa',
      'Mastercard',
      'American Express',
    ];
    const preferred = new Set(preferredOrder);

    [...list.children].forEach((item) => {
      const label = item.querySelector('title')?.textContent?.trim();
      item.hidden = !preferred.has(label);
    });

    preferredOrder.forEach((label) => {
      const item = [...list.children].find(
        (candidate) => candidate.querySelector('title')?.textContent?.trim() === label,
      );
      if (item) list.appendChild(item);
    });

    const heading = document.createElement('p');
    heading.className = 'pc-payment-heading';
    heading.textContent = 'Secure checkout with';
    list.before(heading);

    const more = document.createElement('p');
    more.className = 'pc-payment-more';
    more.textContent = 'and more';
    list.after(more);

    list.dataset.pcTrimmed = 'true';
  };

  const buildTrustStrip = (trustBlock) => {
    if (!trustBlock || trustBlock.querySelector('.pc-trust-strip')) return;

    const proofAssets = [
      {
        source: document.querySelector('img[src*="madeinusa_p"]'),
        alt: 'Made in the USA',
      },
      {
        source: document.querySelector('img[src*="thirdparty_p"]'),
        alt: 'Third party tested',
      },
    ].filter((item) => item.source);

    if (proofAssets.length < 2) return;

    const strip = document.createElement('div');
    strip.className = 'pc-trust-strip';

    proofAssets.forEach(({ source, alt }) => {
      const proof = document.createElement('div');
      proof.className = 'pc-trust-proof';
      const image = source.cloneNode(true);
      image.alt = alt;
      image.removeAttribute('height');
      image.removeAttribute('sizes');
      proof.appendChild(image);
      strip.appendChild(proof);
    });

    trustBlock.appendChild(strip);
    trustBlock.classList.add('pc-trust-has-strip');
    proofAssets[0].source.closest('.shopify-section')?.classList.add('pc-trust-source');
  };

  const protectMobilePurchaseAreaFromChat = (box) => {
    let chatObserver;

    const sync = () => {
      const chat = document.querySelector('#tidio-chat');
      if (!chat) return false;

      const rect = box.getBoundingClientRect();
      const buyboxIsVisible = rect.top < window.innerHeight && rect.bottom > 0;
      chat.classList.toggle('pc-chat-paused', window.innerWidth < 750 && buyboxIsVisible);
      return true;
    };

    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    if (!sync()) {
      chatObserver = new MutationObserver(() => {
        if (sync()) chatObserver.disconnect();
      });
      chatObserver.observe(document.body, { childList: true, subtree: true });
    }
  };

  const buildMobileBuyBar = (box) => {
    const primaryButton = box.querySelector('.pc-cta .product-form__submit');
    if (!primaryButton || document.querySelector('.pc-mobile-buybar')) return;

    const bar = document.createElement('div');
    bar.className = 'pc-mobile-buybar is-hidden';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = `
      <button class="pc-mobile-buybar__button" type="button">
        <span>Add to cart</span>
        <span class="pc-mobile-buybar__price"></span>
      </button>`;

    const button = bar.querySelector('.pc-mobile-buybar__button');
    const label = button.querySelector('span');
    const price = button.querySelector('.pc-mobile-buybar__price');

    const sync = () => {
      const saleText = box.querySelector('.price-item--sale.price-item--last')?.textContent?.trim() || '';
      button.disabled = primaryButton.disabled;
      label.textContent = primaryButton.disabled ? primaryButton.textContent.trim() || 'Unavailable' : 'Add to cart';
      price.textContent = primaryButton.disabled ? '' : saleText;
    };

    button.addEventListener('click', () => {
      if (!primaryButton.disabled) primaryButton.click();
    });

    document.body.appendChild(bar);
    sync();

    new MutationObserver(sync).observe(primaryButton, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const hidden = entry.intersectionRatio >= 0.8;
        bar.classList.toggle('is-hidden', hidden);
        bar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      }, { threshold: 0.2 }).observe(primaryButton);
    } else {
      bar.classList.remove('is-hidden');
      bar.setAttribute('aria-hidden', 'false');
    }
  };

  const suppressDuplicateProductForms = (layout, primaryForm) => {
    const sync = () => {
      layout.querySelectorAll('product-form').forEach((form) => {
        if (form === primaryForm || form.closest('.pc-buybox')) return;
        closestBlock(form)?.classList.add('pc-source-block');
      });
    };

    sync();
    new MutationObserver(sync).observe(layout, { childList: true, subtree: true });
  };

  const enhance = (productInfo) => {
    if (productInfo.dataset.pcBuybox === 'true') return;

    const layout = productInfo.querySelector('two-column-layout');
    const productForms = layout ? [...layout.querySelectorAll('product-form')] : [];
    const productForm =
      productForms.find((form) => {
        const rect = form.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && closestBlock(form)?.querySelector('quantity-input');
      }) || productForms[0];
    if (!layout || !productForm) return;

    const titleBlock = closestBlock(productInfo.querySelector('.product-title'));
    const priceBlock = closestBlock(productInfo.querySelector('[id^="price-"]'));
    const descriptionBlock = closestBlock(productInfo.querySelector('.product-text'));
    const trustBlock = closestBlock(productInfo.querySelector('.trust-badge'));
    const deliveryBlock = closestBlock(productInfo.querySelector('delivery-estimator'));
    const paymentBlock = closestBlock(productInfo.querySelector('.product__payment'));
    const buyBlock = closestBlock(productForm);
    const buyBlocks = [...new Set(productForms.map(closestBlock).filter(Boolean))];
    const quantity = buyBlock?.querySelector('.product-form-quantity');
    const formContainer = productForm.parentElement;
    const accordionBlocks = [
      ...new Set(
        [...productInfo.querySelectorAll('.product-accordion')]
          .map(closestBlock)
          .filter(Boolean),
      ),
    ];

    const valueSource = descriptionBlock?.querySelector('p strong')?.textContent?.trim();
    const valueLine = valueSource ? document.createElement('p') : null;
    if (valueLine) {
      valueLine.className = 'pc-value-line';
      valueLine.textContent = valueSource;
    }

    const box = document.createElement('div');
    box.className = 'pc-buybox';
    box.setAttribute('data-pc-buybox', 'option-1');
    layout.appendChild(box);

    [titleBlock, priceBlock, valueLine].filter(Boolean).forEach((node) => box.appendChild(node));

    const reserved = new Set([
      titleBlock,
      priceBlock,
      descriptionBlock,
      trustBlock,
      deliveryBlock,
      paymentBlock,
      ...buyBlocks,
      ...accordionBlocks,
    ]);

    [...layout.querySelectorAll(':scope > .column-left > .block, :scope > .column-right > .block')]
      .filter((block) => !reserved.has(block) && !block.querySelector('.spacer'))
      .forEach((block) => {
        block.classList.add('pc-supporting-block');
        box.appendChild(block);
      });

    if (quantity) {
      quantity.classList.add('pc-quantity');
      box.appendChild(quantity);
    }

    if (deliveryBlock) {
      deliveryBlock.classList.add('pc-delivery');
      box.appendChild(deliveryBlock);
    }

    if (trustBlock) {
      trustBlock.classList.add('pc-trust');
      buildTrustStrip(trustBlock);
      box.appendChild(trustBlock);
    }

    if (formContainer) {
      formContainer.classList.add('pc-cta');
      box.appendChild(formContainer);
    }

    const govxBlock = closestBlock(box.querySelector('.pc-govx-offer'));
    if (govxBlock) {
      govxBlock.classList.add('pc-govx-block');
      box.appendChild(govxBlock);
    }

    if (paymentBlock) {
      paymentBlock.classList.add('pc-payments');
      trimPaymentMethods(paymentBlock);
      box.appendChild(paymentBlock);
    }

    const paymentStripBlock = closestBlock(box.querySelector('.pc-payment-strip'));
    const productFactsBlock = closestBlock(box.querySelector('.pc-product-facts'));
    [paymentStripBlock, productFactsBlock].filter(Boolean).forEach((block) => {
      box.appendChild(block);
    });

    accordionBlocks.forEach((block) => {
      block.classList.add('pc-accordion');
      box.appendChild(block);
    });

    if (descriptionBlock) {
      descriptionBlock.classList.add('pc-product-copy');
      box.appendChild(descriptionBlock);
    }

    buyBlocks.forEach((block) => block.classList.add('pc-source-block'));
    suppressDuplicateProductForms(layout, productForm);
    productInfo.dataset.pcBuybox = 'true';
    document.body.classList.add('pc-buybox-ready');
    updateSavings(productInfo);
    protectMobilePurchaseAreaFromChat(box);
    buildMobileBuyBar(box);

    const priceRoot = productInfo.querySelector('[id^="price-"]');
    if (priceRoot) {
      new MutationObserver(() => updateSavings(productInfo)).observe(priceRoot, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  };

  const init = (root = document) => {
    root.querySelectorAll('product-info').forEach(enhance);
  };

  const start = () => window.requestAnimationFrame(() => init());
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
